<template>
    <div>
    <Cbarra>
        <template slot="slotTitle">Administración</template>
        <template slot="slotRoute">
            <router-link :to="{name:'index'}">Inicio</router-link> / <router-link :to="{name:'administracion'}">Administración</router-link>
        </template>
    </Cbarra>

    <section class="container justify-content-center">
        <div class="bg-principal">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 shadow_principal">
                    <div class="nav flex-column nav-pills bolt mt-4 mb-5" id="v-pills-tab" role="tablist"
                        aria-orientation="vertical">
                        <a class="nav-link active" id="v-pills-01-tab" data-toggle="pill" href="#v-pills-01" role="tab"
                            aria-controls="v-pills-01" aria-selected="true">
                            Secretaría Administrativa
                        </a>
                        <div class="nav-link title-call">
                            Departamentos <i class="fas fa-angle-down color8 ml-1"></i>
                        </div>
                        <a class="nav-link sub-menu" id="v-pills-02-tab" data-toggle="pill" href="#v-pills-02"
                            role="tab" aria-controls="v-pills-02" aria-selected="false">
                            Depto. de Personal
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-03-tab" data-toggle="pill" href="#v-pills-03"
                            role="tab" aria-controls="v-pills-03" aria-selected="false">
                            Depto. de Contabilidad y Presupuesto
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-04-tab" data-toggle="pill" href="#v-pills-04"
                            role="tab" aria-controls="v-pills-04" aria-selected="false">
                            Depto. de Bienes y Suministros
                        </a>
                        <a class="nav-link sub-menu" id="v-pills-05-tab" data-toggle="pill" href="#v-pills-05"
                            role="tab" aria-controls="v-pills-05" aria-selected="false">
                            Superintendencia de Obras y Servicios Generales
                        </a>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9">
                    <div class="tab-content mt-4 mb-5" id="v-pills-tabContent">

                        <div class="tab-pane fade show active" id="v-pills-01" role="tabpanel" aria-labelledby="v-pills-01-tab">
                            <div  v-for="(lista,key) in objTab1.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>

                        <div class="tab-pane fade" id="v-pills-02" role="tabpanel" aria-labelledby="v-pills-02-tab">
                            <div  v-for="(lista,key) in objTab2.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>

                        <div class="tab-pane fade" id="v-pills-03" role="tabpanel" aria-labelledby="v-pills-03-tab">
                            <div  v-for="(lista,key) in objTab3.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>

                        <div class="tab-pane fade" id="v-pills-04" role="tabpanel" aria-labelledby="v-pills-04-tab">
                            <div  v-for="(lista,key) in objTab4.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>

                        <div class="tab-pane fade" id="v-pills-05" role="tabpanel" aria-labelledby="v-pills-05-tab">
                            <div  v-for="(lista,key) in objTab5.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <!-- <CImagenes v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CImagenes> -->

                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>
                                            </div>
                                            
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>

                        
                    </div>
                </div>
            </div>
        </div>
    </section>

  </div>
</template>

<script>
export default {
    data() {
        return {
          urlApi:"inicio/investigacion",
            ListaContenido:[],
            oferta:{},
            Segurity:{},
            ConfCatalogo:{
				title:'Igualdadgenero',
				isModal: true,
				obj: {}
            },
            ConfFiltro:{
				placeHSearch:'Puesto',
				valueSearch:'',
				entrada:25,
				pag:1,
				totalItems:0,
				pageSize:0,
            },
            ConfAcciones:{
            },
            ConfigBtnModal2:{
                emitAdd: 'NuevoModal2',
                emitDel: 'EliminarDetalle'
            },
            configBtnContactos:{
                emitAdd: 'FormContactos',
                emitDel: 'DeleteContactos',
            },
			ConfModal: {
				ShowPie: true,
                Size:'md',
            },
            oBoton1:{
                NameOk:'Crear',
                ShowPie:true,
            },
            oModal2:{
                Titulo: 'Detalles del Tema',
                Size:'lg',
            },
            oBoton2:{
                TipoModal:2,
                ShowPie:true,
            },
            objTema1:{
                editar:false,
                Apartado: 'ADMINSECRETARIA',
                Realiza: 'AddTema'
            },
            objTab1:{
                editar:false,
                Apartado: 'ADMINSECRETARIA',
                ListaDet: [],
            },

            objTema2:{
                editar:false,
                Apartado: 'ADMINDEPTOPERSONAL',
                Realiza: 'AddTema'
            },
            objTab2:{
                editar:false,
                Apartado: 'ADMINDEPTOPERSONAL',
                ListaDet: [],
            },

            objTema3:{
                editar:false,
                Apartado: 'ADMINDEPTOCONTABILIDAD',
                Realiza: 'AddTema'
            },
            objTab3:{
                editar:false,
                Apartado: 'ADMINDEPTOCONTABILIDAD',
                ListaDet: [],
            },

            objTema4:{
                editar:false,
                Apartado: 'ADMINDEPTOBIENES',
                Realiza: 'AddTema'
            },
            objTab4:{
                editar:false,
                Apartado: 'ADMINDEPTOBIENES',
                ListaDet: [],
            },

            objTema5:{
                editar:false,
                Apartado: 'ADMINSUPERINTENDENCIA',
                Realiza: 'AddTema'
            },
            objTab5:{
                editar:false,
                Apartado: 'ADMINSUPERINTENDENCIA',
                ListaDet: [],
            },

            RutaFile: '',
            RutaFileD: '',
            listIconos: [],
            contactReturn: 'Administracion',
        }
    },
    methods:
    {
        nuevo(Id,obj)
        {
            let newObj = {
                Apartado: obj.Apartado,
                Seccion: 'IGUALDADGENERO',
                Arealizar: obj.Realiza,
                IdTema: obj.IdTema,
            }
            this.bus.$emit("NuevoModal", Id, newObj);
        },
        Eliminar(Id) {
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                icon: 'warning'
            }).then((result) => {
                if(result.value) {
                    this.$http.delete('tema/'+Id).then( (res) => {
                        this.$toast.success('Información eliminada');
                        this.Lista();
                    }).catch( err => {
                        this.$toast.error(err.response.data.message);
                    });
				}
			});
        },
        async Lista()
        {
            await this.$http.get(this.urlApi, {
					params:{Seccion:'ADMINISTRACION',TxtBusqueda:'',Entrada:'',pag:'',RegEstatus: 'A',Orden:'SI'}
                }
            ).then((res) => {
				this.ConfFiltro.pag			= res.data.pagination.CurrentPage;
				this.ConfFiltro.totalItems 	= res.data.pagination.TotalItems;
				this.ConfFiltro.pageSize	= res.data.pagination.PageSize;
                this.Segurity				= res.data.segurity;
                this.RutaFile               = res.data.RutaFile;
                this.RutaFileD              = res.data.RutaFileD;
                this.listIconos             = res.data.listIconos;
                
                let newObj1 = [];
                let newObj2 = [];
                let newObj3 = [];
                let newObj4 = [];
                let newObj5 = [];

               
                $.each(res.data.tema, function(key, value)
                {
                    if(value.Apartado == 'ADMINSECRETARIA'){
                        newObj1.push(value)
                    }
                    else if(value.Apartado == 'ADMINDEPTOPERSONAL'){
                        newObj2.push(value)
                    } 
                    else if(value.Apartado == 'ADMINDEPTOCONTABILIDAD'){
                        newObj3.push(value)
                    }                     
                    else if(value.Apartado == 'ADMINDEPTOBIENES'){
                        newObj4.push(value)
                    }  
                    else if(value.Apartado == 'ADMINSUPERINTENDENCIA'){
                        newObj5.push(value)
                    }  
                });
                if(newObj1.length > 0){
                    this.objTab1.editar = true;
                    this.objTab1.ListaDet = newObj1;
                }
                if(newObj2.length > 0){
                    this.objTab2.editar = true;
                    this.objTab2.ListaDet = newObj2;
                }
                if(newObj3.length > 0){
                    this.objTab3.editar = true;
                    this.objTab3.ListaDet = newObj3;
                }
                if(newObj4.length > 0){
                    this.objTab4.editar = true;
                    this.objTab4.ListaDet = newObj4;
                }
                if(newObj5.length > 0){
                    this.objTab5.editar = true;
                    this.objTab5.ListaDet = newObj5;
                }
            });
        },
    },mounted() {
        window.scrollTo(0, 0);
        this.Lista();
    },
}
</script>